<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Icon" });
import Tooltip from "../tooltip/Tooltip.svelte";
import Archive from "./assets/archive.svelte";
import ArrowDown from "./assets/arrow-down.svelte";
import ArrowLeft from "./assets/arrow-left.svelte";
import ArrowRight from "./assets/arrow-right.svelte";
import ArrowSort from "./assets/arrow-sort.svelte";
import ArrowSquareRight from "./assets/arrow-square-right.svelte";
import ArrowUp from "./assets/arrow-up.svelte";
import BadgeCheck from "./assets/badge-check.svelte";
import Basket from "./assets/basket.svelte";
import Chart from "./assets/chart.svelte";
import Check from "./assets/check.svelte";
import ChevronDoubleDown from "./assets/chevron-double-down.svelte";
import ChevronDoubleUp from "./assets/chevron-double-up.svelte";
import ChevronDown from "./assets/chevron-down.svelte";
import ChevronRight from "./assets/chevron-right.svelte";
import ChevronUp from "./assets/chevron-up.svelte";
import CircleCheck from "./assets/circle-check.svelte";
import CircleLineUp from "./assets/circle-line-up.svelte";
import Close from "./assets/close.svelte";
import Comparison from "./assets/comparison.svelte";
import Copy from "./assets/copy.svelte";
import CopyLink from "./assets/copy-link.svelte";
import Delete from "./assets/delete.svelte";
import Discount from "./assets/discount.svelte";
import Download from "./assets/download.svelte";
import DownloadFile from "./assets/download-file.svelte";
import Edit from "./assets/edit.svelte";
import File from "./assets/file.svelte";
import Filter from "./assets/filter.svelte";
import Financing from "./assets/financing.svelte";
import GoogleDrive from "./assets/google-drive.svelte";
import HeartCheck from "./assets/heart-check.svelte";
import Help from "./assets/help.svelte";
import Hide from "./assets/hide.svelte";
import LinkedIn from "./assets/linkedin.svelte";
import Loading from "./assets/loading.svelte";
import Location from "./assets/location.svelte";
import Mail from "./assets/mail.svelte";
import MessageHeart from "./assets/message-heart.svelte";
import More from "./assets/more.svelte";
import Offline from "./assets/offline.svelte";
import Online from "./assets/online.svelte";
import Package from "./assets/package.svelte";
import Partial from "./assets/partial.svelte";
import Pause from "./assets/pause.svelte";
import Percent from "./assets/percent.svelte";
import Phone from "./assets/phone.svelte";
import Play from "./assets/play.svelte";
import Plus from "./assets/plus.svelte";
import ReOrder from "./assets/re-order.svelte";
import Reset from "./assets/reset.svelte";
import Search from "./assets/search.svelte";
import Share from "./assets/share.svelte";
import Show from "./assets/show.svelte";
import Smatch from "./assets/smatch.svelte";
import SmileyHappy from "./assets/smiley-happy.svelte";
import SmileySad from "./assets/smiley-sad.svelte";
import SmileyUndecided from "./assets/smiley-undecided.svelte";
import SquareCheck from "./assets/square-check.svelte";
import Tag from "./assets/tag.svelte";
import Unknown from "./assets/unknown.svelte";
import Whatsapp from "./assets/whatsapp.svelte";
const ICONS = {
    archive: Archive,
    arrowDown: ArrowDown,
    arrowLeft: ArrowLeft,
    arrowRight: ArrowRight,
    arrowSort: ArrowSort,
    arrowSquareRight: ArrowSquareRight,
    arrowUp: ArrowUp,
    badgeCheck: BadgeCheck,
    basket: Basket,
    chart: Chart,
    check: Check,
    chevronDoubleDown: ChevronDoubleDown,
    chevronDoubleUp: ChevronDoubleUp,
    chevronDown: ChevronDown,
    chevronRight: ChevronRight,
    chevronUp: ChevronUp,
    circleCheck: CircleCheck,
    circleLineUp: CircleLineUp,
    close: Close,
    comparison: Comparison,
    copy: Copy,
    delete: Delete,
    discount: Discount,
    download: Download,
    downloadFile: DownloadFile,
    edit: Edit,
    file: File,
    filter: Filter,
    financing: Financing,
    googleDrive: GoogleDrive,
    heartCheck: HeartCheck,
    help: Help,
    hide: Hide,
    link: CopyLink,
    linkedIn: LinkedIn,
    loading: Loading,
    location: Location,
    mail: Mail,
    messageHeart: MessageHeart,
    more: More,
    offline: Offline,
    online: Online,
    package: Package,
    partial: Partial,
    pause: Pause,
    percent: Percent,
    phone: Phone,
    play: Play,
    plus: Plus,
    reOrder: ReOrder,
    reset: Reset,
    search: Search,
    share: Share,
    show: Show,
    smatch: Smatch,
    smileyHappy: SmileyHappy,
    smileySad: SmileySad,
    smileyUndecided: SmileyUndecided,
    squareCheck: SquareCheck,
    tag: Tag,
    unknown: Unknown,
    whatsapp: Whatsapp
};
export let key = "plus";
export let label = "";
export let css = "";
export let isScaling = true;
let isTooltipVisible = false;
const setTooltipVisibility = (isHover) => {
    isTooltipVisible = isHover;
};
$: icon = ICONS[key];
</script>

<svelte:component
    this = { icon }
    on:mouseenter = { setTooltipVisibility.bind(null, true) }
    on:mouseleave = { setTooltipVisibility.bind(null, false) }
    on:keypress
    on:click
    { css }
    { isScaling }
/>

{#if label !== ''}
    <div class = 's8-tooltip-container'>
        <Tooltip position = 'south' isVisible = { isTooltipVisible }>
            { label }
        </Tooltip>
    </div>
{/if}

<style>
    :global(svg.s8-icon) {
        cursor: pointer;
        height: 15px;
    }

    div.s8-tooltip-container {
        position: relative;
    }</style>